document.addEventListener("DOMContentLoaded", function () {
  setFilterTriggers();
  setFilterTriggersMobile();
  setMobileFilterToggle();
  setSelectedTags();
  setSelectedTags("-mobile");
  setSelectedSizes();
  setSelectedSizes("-mobile");
  setOptionsFiltersBackgroundColor("option");
  setOptionsFiltersBackgroundColor("tag");
  setFilterSvgBackgroundColor();
  // setContentContainersLoadedState();

  handleSortOptionsClicked();

  const sortByQuery = getQueryParameters().get("sort_by");

  if (sortByQuery) {
    if (sortByQuery === "best-sellers" || sortByQuery === "new-arrivals") {
      let baseUrl = "";

      if (sortByQuery === "best-sellers") {
        baseUrl = "/collections/bestsellers";
      } else if (sortByQuery === "new-arrivals") {
        baseUrl = "/collections/new-arrivals";
      }

      let currentUrl = new URL(window.location.href);
      let newUrl = new URL(baseUrl, currentUrl.origin);
      currentUrl.searchParams.forEach((value, key) => {
        if (key !== "sort_by") {
          newUrl.searchParams.append(key, value);
        }
      });
      window.location.href = newUrl.href;
      return;
    }

    if (sortByQuery === "sale") {
      handleSortBySale();
    }

    const sortOption = document.querySelector(
      `.section-filter__dropdown-item[data-option='${sortByQuery}']`
    );
    const sortOptionMobile = document.querySelector(
      `.section-filter__dropdown-item-mobile[data-option='${sortByQuery}']`
    );
    const sortOptions = document.querySelectorAll(
      ".section-filter__dropdown-content[data-filter-type='sort'] .section-filter__dropdown-item"
    );
    const sortOptionsMobile = document.querySelectorAll(
      ".section-filter__dropdown-content-mobile[data-filter-type='sort'] .section-filter__dropdown-item-mobile"
    );
    sortOptions.forEach((option) => {
      option.setAttribute("data-selected", "false");
    });
    sortOptionsMobile.forEach((option) => {
      option.setAttribute("data-selected", "false");
    });
    sortOption.setAttribute("data-selected", "true");
    sortOptionMobile.setAttribute("data-selected", "true");
    addCheckmarkToFilter(sortOption);
    addCheckmarkToFilter(sortOptionMobile, "-mobile");
    setOptionsFiltersBackgroundColor("sort");
  }
});

function handleSortOptionsClicked() {
  const sortOptions = document.querySelectorAll(
    ".section-filter__dropdown-content[data-filter-type='sort'] .section-filter__dropdown-item"
  );

  sortOptions.forEach((option) => {
    option.addEventListener("click", function (e) {
      const isSelected = e.target.getAttribute("data-selected") === "true";
      if (!isSelected) {
        const sortOptions = document.querySelectorAll(
          ".section-filter__dropdown-content[data-filter-type='sort'] .section-filter__dropdown-item"
        );
        sortOptions.forEach((option) => {
          option.setAttribute("data-selected", "false");
        });
      }
      e.target.setAttribute(
        "data-selected",
        isSelected === true ? "false" : "true"
      );

      buildQuerystring();
    });
  });

  const sortOptionsMobile = document.querySelectorAll(
    ".section-filter__dropdown-content-mobile[data-filter-type='sort'] .section-filter__dropdown-item-mobile"
  );

  sortOptionsMobile.forEach((option) => {
    option.addEventListener("click", function (e) {
      const isSelected = e.target.getAttribute("data-selected") === "true";
      if (!isSelected) {
        const sortOptions = document.querySelectorAll(
          ".section-filter__dropdown-content-mobile[data-filter-type='sort'] .section-filter__dropdown-item-mobile"
        );
        sortOptions.forEach((option) => {
          option.setAttribute("data-selected", "false");
        });
      }
      e.target.setAttribute(
        "data-selected",
        isSelected === true ? "false" : "true"
      );

      buildQuerystring("-mobile");
    });
  });
}

function handleSortBySale() {
  const products = document.querySelectorAll(".grid-product");
  const productsOnSale = [];
  const regularProducts = [];
  // separate products on sale from regular products
  products.forEach((product) => {
    const hasSale = product.querySelector(".grid-product__tag--sale");
    if (hasSale) {
      productsOnSale.push(product);
    } else {
      regularProducts.push(product);
    }
  });
  setGridCollectionOrder([productsOnSale, regularProducts]);
}

function setGridCollectionOrder(collectionGroups) {
  const gridCollection = document.querySelector(".grid--collection");
  gridCollection.innerHTML = "";
  collectionGroups.forEach((group) => {
    group.forEach((product) => {
      gridCollection.appendChild(product);
    });
  });
}

function setContentContainersLoadedState() {
  // check if url params exist
  const params = getQueryParameters();
  const url = new URL(window.location.href);
  if (params.size > 0) {
    // setting mobile triggers and content containers
    document
      .querySelectorAll(".section-filter__mobile-dropdown-container")
      .forEach((container) => container.classList.toggle("active"));
    document
      .querySelectorAll(".section-filter__dropdown-content-mobile")
      .forEach((submenu) => submenu.classList.add("active"));
    document
      .querySelectorAll(".section-filter__dropdown-trigger-mobile")
      .forEach((trigger) => trigger.classList.add("active"));

    document
      .querySelectorAll(".section-filter__dropdown-content")
      .forEach((container) => {
        if (
          container.getAttribute("data-filter-type") === "sort" &&
          params.get("sort_by")
        ) {
          container.classList.toggle("active");
        }
        if (
          container.getAttribute("data-filter-type") === "option" &&
          params.get("filter.v.option.size")
        ) {
          container.classList.toggle("active");
        }
        if (
          container.getAttribute("data-filter-type") === "tag" &&
          (url.pathname.endsWith("festival") ||
            url.pathname.endsWith("solid-color"))
        ) {
          container.classList.toggle("active");
        }
      });
  }
}

function setFilterSvgBackgroundColor() {
  const activeOptions = document.querySelectorAll(
    `.section-filter__dropdown-content-mobile[data-filter-type='option'] .section-filter__dropdown-item-mobile[data-selected="true"]`
  );
  const activeTags = document.querySelectorAll(
    `.section-filter__dropdown-content-mobile[data-filter-type='tag'] .section-filter__dropdown-item-mobile[data-selected="true"]`
  );

  if (activeOptions.length > 0 || activeTags.length > 0) {
    const filterSvg = document.querySelector(".filter-funnel-svg");
    filterSvg.style.fill = "#ffc700";
  }
}

function setOptionsFiltersBackgroundColor(filterType) {
  const optionFilters = document.querySelectorAll(
    `.section-filter__dropdown-content[data-filter-type='${filterType}'] .section-filter__dropdown-item`
  );

  const optionFiltersSelected = document.querySelectorAll(
    `.section-filter__dropdown-content[data-filter-type='${filterType}'] .section-filter__dropdown-item[data-selected='true']`
  );

  if (
    optionFiltersSelected.length < optionFilters.length &&
    optionFiltersSelected.length > 0
  ) {
    const filterElement = document.querySelector(
      `.section-filter__dropdown-trigger[data-filter-type='${filterType}']`
    );
    filterElement.classList.add("selected");
  }
}

function setSelectedSizes(mode = "") {
  // get url params with: filter.v.option.size
  const params = getQueryParameters();
  const sizes = params.getAll("filter.v.option.size");
  const filterSizes = document.querySelectorAll(
    `.section-filter__dropdown-content${mode}[data-filter-type='option'] .section-filter__dropdown-item${mode}`
  );

  filterSizes.forEach((filterSize) => {
    if (sizes.includes(filterSize.getAttribute("data-option"))) {
      addCheckmarkToFilter(filterSize, mode);
      filterSize.setAttribute("data-selected", "true");
    }
  });
}

function setFilterTriggers() {
  const filterTriggers = document.querySelectorAll(
    ".section-filter__dropdown-trigger"
  );

  filterTriggers.forEach((trigger) => {
    const children = trigger.nextElementSibling.children;
    if (trigger.getAttribute("data-filter-type") !== "sort") {
      for (i = 0; i < children.length; i++) {
        children[i].addEventListener("click", function (e) {
          const isSelected = e.target.getAttribute("data-selected") === "true";
          e.target.setAttribute(
            "data-selected",
            isSelected === true ? "false" : "true"
          );

          buildQuerystring();
        });
      }
    }

    trigger.addEventListener("click", function (e) {
      e.target.nextElementSibling.classList.toggle("active");

      document
        .querySelector(
          `.section-filter__dropdown-trigger[data-filter-type='${e.target.getAttribute(
            "data-filter-type"
          )}']`
        )
        ?.classList.toggle("active");
    });
  });
}

function setFilterTriggersMobile() {
  const filterTriggers = document.querySelectorAll(
    ".section-filter__dropdown-trigger-mobile"
  );

  filterTriggers.forEach((trigger) => {
    const children = trigger.parentElement.nextElementSibling.children;
    if (trigger.getAttribute("data-filter-type") !== "sort") {
      for (i = 0; i < children.length; i++) {
        children[i].addEventListener("click", function (e) {
          const isSelected = e.target.getAttribute("data-selected") === "true";
          e.target.setAttribute(
            "data-selected",
            isSelected === true ? "false" : "true"
          );

          buildQuerystring("-mobile");
        });
      }
    }

    trigger.addEventListener("click", function (e) {
      e.target.parentElement?.nextElementSibling?.classList?.toggle("active");

      document
        .querySelector(
          `.section-filter__dropdown-trigger-mobile[data-filter-type='${e.target.getAttribute(
            "data-filter-type"
          )}']`
        )
        ?.classList.toggle("active");
    });
  });
}

function setSelectedTags(mode = "") {
  const url = window.location.href;
  const dirs = url.split("/");
  const allowedCollections = [
    "meggings",
    "shorts",
    "tops",
    "bike",
    "bestsellers",
    "solid-colors",
    "prints-collection",
    "black-gray-collection",
    "camo-collection",
    "pride-collection",
    "sale",
    "new-arrivals",
  ];

  if (allowedCollections.includes(dirs[dirs.length - 1].split("?")[0])) {
    return;
  }

  const tags = dirs[dirs.length - 1].split("+");

  tags.forEach((tag) => {
    tag = tag.split("?")[0];
    const tagFilter = document.querySelector(
      `.section-filter__dropdown-item${mode}[data-tag='${tag}']`
    );
    if(tagFilter){
      addCheckmarkToFilter(tagFilter, mode);
      tagFilter.setAttribute("data-selected", "true");
    }
  });
}

function addCheckmarkToFilter(filter, mode = "") {
  if (!filter) {
    return;
  }

  const checkMark = `<div class="check-mark${mode}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 7">
  <path d="M9 1L3.5 6.5L1 4" stroke="#FFC700" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></div>`;

  // if (mode === "-mobile") {
  filter.innerHTML = checkMark + filter.innerHTML;
  return;
  // }

  // filter.innerHTML += checkMark;
}

function appendQueryParameter(key, value) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  params.append(key, value);
  window.location.href = `${url.origin}${url.pathname}?${params.toString()}`;
}

function removeQueryParameter(key) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  params.delete(key);
  window.location.href = `${url.origin}${url.pathname}?${params.toString()}`;
}

function getQueryParameters() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  return params;
}

function buildQuerystring(mode = "") {
  const tags = document.querySelectorAll(
    `.section-filter__dropdown-content${mode}[data-filter-type='tag'] .section-filter__dropdown-item${mode}[data-selected='true']`
  );

  const totalOptions = document.querySelectorAll(
    `.section-filter__dropdown-content${mode}[data-filter-type='option'] .section-filter__dropdown-item${mode}`
  ).length;

  const selectedOptions = document.querySelectorAll(
    `.section-filter__dropdown-content${mode}[data-filter-type='option'] .section-filter__dropdown-item${mode}[data-selected='true']`
  );

  const selectedSortBy = document.querySelector(
    `.section-filter__dropdown-content${mode}[data-filter-type='sort'] .section-filter__dropdown-item${mode}[data-selected='true']`
  );

  let queryString = "";

  if (tags.length === 1) {
    queryString += "/";
    queryString += tags[0].getAttribute("data-tag");
  }

  if (selectedOptions.length < totalOptions) {
    selectedOptions.forEach((option, index) => {
      if (index === 0) {
        queryString += "?";
      } else {
        queryString += "&";
      }

      queryString += `filter.v.option.size=${option.getAttribute(
        "data-option"
      )}`;
    });
    if (selectedOptions.length > 0) {
      queryString += "&filter.v.availability=1";
    }
  }

  if (selectedSortBy) {
    if (queryString.length > 0) {
      queryString += "&";
    } else {
      queryString += "?";
    }
    queryString += `sort_by=${selectedSortBy.getAttribute("data-option")}`;
  }
  const currentLocation = window.location.href.split("/");
  window.location.href =
    `/collections/${currentLocation[4].split("?")[0]}` + queryString;
}

function toggleElementVisibility(element) {
  element.classList.toggle("active");
  // const currentVisibility = element.style.visibility;
  // element.style.visibility =
  //   currentVisibility === "hidden" || currentVisibility === ""
  //     ? "visible"
  //     : "hidden";
}

function setMobileFilterToggle() {
  const mobileFilterMenuToggle = document.querySelector(".filter-funnel-svg");
  if(mobileFilterMenuToggle){
    mobileFilterMenuToggle.addEventListener("click", function () {
      toggleElementVisibility(
        document.querySelector(".section-filter__mobile-dropdown-container")
      );
    });
  }
}

function loadFiveReasonsMobileSlider(element) {
  document.querySelector(
    element
  ).innerHTML = `<div class="five-reasons-mobile-holder">
    <a href="javascript:void(0);" onClick="jQuery('.five-reasons-mobile-holder').fadeOut();" class="five-reasons-mobile__close" aria-label="Close Five Reasons">&times;</a>
      <div class="five-reasons-mobile responsive-banner" data-slick='{"variableWidth": false, "slidesToShow": 4, "centerMode": false}'>
        <div>
          <img src="https://succeed.agency/cro/matador19012023/modesty-pad.svg" style="width: 25vw; object-fit:contain; object-position: center; height: 95px;" alt="Modesty Pad" />
        </div>
        <div>
          <img src="https://succeed.agency/cro/matador19012023/phone-pocket.svg" style="width: 25vw; object-fit:contain; object-position: center; height: 95px;" alt="Phone Pocket" />
        </div>
        <div>
          <img src="https://succeed.agency/cro/matador19012023/t-shirt-loop.svg" style="width: 25vw; object-fit:contain; object-position: center; height: 95px;" alt="T-Shirt Loop" />
        </div>
        <div>
          <img src="https://succeed.agency/cro/matador19012023/zipper-pocket.svg" style="width: 25vw; object-fit:contain; object-position: center; height: 95px;" alt="Zipper Pocket" />
        </div>
        <div>
          <img src="https://succeed.agency/cro/matador19012023/inner-drawstring.svg" style="width: 25vw; object-fit:contain; object-position: center; height: 95px;" alt="Inner Drawstring" />
        </div>
      </div>
    </div>`;
}
